"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Inner_1 = require("./Inner");
tslib_1.__exportStar(require("./QueryLoader"), exports);
tslib_1.__exportStar(require("./LoadingState"), exports);
tslib_1.__exportStar(require("./Inner"), exports);
tslib_1.__exportStar(require("./UndesiredState"), exports);
tslib_1.__exportStar(require("./ReadyState"), exports);
tslib_1.__exportStar(require("./context"), exports);
tslib_1.__exportStar(require("./hooks"), exports);
function OsmosysCanvasPage({ children, onQueryChange, onRouteChange, defaultPrefs, }) {
    return (react_1.default.createElement(Inner_1.OsmosysCanvasPageInner, { onQueryChange: onQueryChange, defaultPrefs: defaultPrefs, onRouteChange: onRouteChange }, children));
}
exports.OsmosysCanvasPage = OsmosysCanvasPage;
//# sourceMappingURL=index.js.map